import { AllActionsTypes } from "../actions_all";
import { PopulationDistribution, PopulationData } from "../../../src/Dashboard/Protocol/types";


interface ScoreDistribution {
    score: string
    distribution: { x: number[], y: number[] }
    population: PopulationData
}

export interface FeatureDisplayPopulation {
    score_distributions: ScoreDistribution[];
}

export interface DataState {
    population_feature_distributions?: Map<string, PopulationDistribution[]>
    populations: PopulationData[]
    population_stats_data: { [key: string]: FeatureDisplayPopulation }
}

export const SET_POPULATION_FEATURE_DISTRIBUTIONS = 'SET_POPULATION_FEATURE_DISTRIBUTIONS';
export const CLEAR_POPULATION_FEATURE_DISTRIBUTIONS = 'CLEAR_POPULATION_FEATURE_DISTRIBUTION';
export const SET_POPULATION_DATA = 'SET_POPULATION_DATA';
export const CLEAR_POPULATION_DATA = 'CLEAR_POPULATION_DATA';
export const ADD_POPULATION_STATS_DATA = 'SET_POPULATION_STATS_DATA';
export const CLEAR_POPULATION_STATS_DATA = 'CLEAR_POPULATION_STATS_DATA';

export interface setPopulationFeatureDistributionsAction {
    type: typeof SET_POPULATION_FEATURE_DISTRIBUTIONS,
    payload: Map<string, PopulationDistribution[]>
}

export interface clearPopulationFeatureDistributionsAction {
    type: typeof CLEAR_POPULATION_FEATURE_DISTRIBUTIONS
}

export interface setPopulationDataAction {
    type: typeof SET_POPULATION_DATA,
    payload: PopulationData[]
}

export interface clearPopulationDataAction {
    type: typeof CLEAR_POPULATION_DATA
}

export interface addPopulationStatsDataAction {
    type: typeof ADD_POPULATION_STATS_DATA,
    payload: { [key: string]: FeatureDisplayPopulation }
}
export interface clearPopulationStatsDataAction {
    type: typeof CLEAR_POPULATION_STATS_DATA
}

export type DataActionTypes =
    | setPopulationFeatureDistributionsAction
    | clearPopulationFeatureDistributionsAction
    | setPopulationDataAction
    | clearPopulationDataAction
    | addPopulationStatsDataAction
    | clearPopulationStatsDataAction
    | AllActionsTypes;
